/* Progressive FAQ enhancement: answers and FAQ microdata remain in the HTML. */
(() => {
  const article = document.querySelector('article[data-ag-tds]');
  if (!article) return;

  article.querySelectorAll('.ag-tds__faq button[aria-controls]').forEach((button, index) => {
    const panel = document.getElementById(button.getAttribute('aria-controls'));
    if (!panel || !article.contains(panel) || button.dataset.tdsReady) return;
    button.dataset.tdsReady = 'true';
    const setExpanded = (expanded) => {
      button.setAttribute('aria-expanded', String(expanded));
      panel.hidden = !expanded;
    };
    button.addEventListener('click', () => {
      setExpanded(button.getAttribute('aria-expanded') !== 'true');
    });
    setExpanded(index === 0);
  });

  // The shared picker currently initializes only on collection/home surfaces.
  // Bind the existing article shelf without changing its forms or variant data.
  const section = article.closest('.shopify-section');
  section?.querySelectorAll('.ag-tikman [data-card-product]').forEach((card) => {
    const select = card.querySelector('[data-card-variant-select]');
    const input = card.querySelector('[data-variant-id]');
    const data = card.querySelector('[data-card-variants]');
    if (!select || !input || !data || card.dataset.variantPickerReady === 'true') return;
    let variants;
    try { variants = JSON.parse(data.textContent); } catch { return; }
    if (!Array.isArray(variants)) return;
    const price = card.querySelector('[data-card-price]');
    const button = card.querySelector('[data-add-to-cart]');
    const title = card.querySelector('.ag-fc-card__title-link')?.textContent.trim();
    const money = new Intl.NumberFormat('en-PH', {
      style: 'currency', currency: card.dataset.cardCurrency || 'PHP',
      minimumFractionDigits: 0, maximumFractionDigits: 2
    });
    const update = () => {
      const variant = variants.find((item) => String(item.id) === select.value);
      if (!variant) return;
      input.value = variant.id;
      if (price) price.textContent = money.format(variant.price / 100);
      const weight = card.querySelector('[data-card-weight-label]');
      if (weight) weight.textContent = variant.title;
      if (button) {
        button.disabled = !variant.available;
        const label = variant.available ? button.dataset.defaultLabel : button.dataset.soldOutLabel;
        const text = button.querySelector('span');
        if (text && label) text.textContent = label;
        if (title && label) button.setAttribute('aria-label', `${title} — ${variant.title} ${price?.textContent || ''} — ${label}`);
      }
    };
    card.dataset.variantPickerReady = 'true';
    select.addEventListener('change', update);
    update();
  });
})();
